import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgJackpot = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width={16}
    height={14}
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.2665 3.61583L11.9633 0.218047C11.827 0.0777746 11.6476 0 11.4614 0L4.53462 0.00486089C4.34833 0.00486089 4.16896 0.0833301 4.03302 0.223602L0.73328 3.6259C0.448495 3.91963 0.420803 4.40746 0.670344 4.73766L7.44006 13.7078C7.73429 14.0977 8.2768 14.0973 8.57071 13.7071L15.3304 4.72759C15.5793 4.3967 15.5513 3.90887 15.2662 3.61583H15.2665Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgJackpot)
const IconSvgJackpot = createIcon(ForwardRef, 'SvgJackpot')
export default IconSvgJackpot
